import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { List } from "immutable";
import { classNamesConfig } from "../../../../Shared/features/classnames";
import { Link } from "../library/link";
import { Teasers } from "../teaser";
const React = require("react");
export const RecentNewsBlockLayout = (props)=>{
    const items = props.items.kind == 'loaded' ? props.items.value : [];
    const classNames = classNamesConfig().recent_news;
    return /*#__PURE__*/ _jsxs("section", {
        className: `block block--content-grid ${classNames.block}`,
        children: [
            props.title && props.title != "" && /*#__PURE__*/ _jsx("header", {
                className: `block__header ${classNames.inner}`,
                children: /*#__PURE__*/ _jsx("h2", {
                    className: "block__title title--l container--xs",
                    children: props.title
                })
            }),
            /*#__PURE__*/ _jsx(Teasers, {
                items: List(items)
            }),
            props.linkTitle && props.linkUrl && /*#__PURE__*/ _jsx("footer", {
                className: `block__actions ${classNames.inner}`,
                children: /*#__PURE__*/ _jsx(Link, {
                    className: "button button--primary button--arrow",
                    url: props.linkUrl,
                    children: /*#__PURE__*/ _jsx("span", {
                        className: "button__label",
                        children: props.linkTitle
                    })
                })
            })
        ]
    }, props.key);
};
